module.exports = __webpack_public_path__ + "img/logo.1edec14252a020faa6735f54b3cc292a.svg";